import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-151ecfa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_2 = { class: "mod_c_title" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = {
  key: 0,
  class: "red-packet-list"
}
const _hoisted_5 = { class: "flex between" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { style: {"color":"#f83a3a"} }
const _hoisted_8 = { class: "flex between" }
const _hoisted_9 = { class: "flex create-btn" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "红包类型：", -1))
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "not-use" }, null, -1))
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "used" }, null, -1))
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "refunded" }, null, -1))
const _hoisted_21 = {
  key: 0,
  class: "implement-text"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "剩余金额将回退至总金额。", -1))
const _hoisted_24 = ["src", "onClick"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "winners-info flex between" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { style: {"margin-left":"0"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "红包模式：", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开始时间：", -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "红包总金额：", -1))
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "领取金额：", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "领取人数：", -1))
const _hoisted_36 = { class: "winners-table" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { style: {"min-height":"500px"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "充值金额", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "支付金额≥1元含3%手续费，最小金额100元，最大金额10万元。", -1))
const _hoisted_41 = { class: "packet-pay" }
const _hoisted_42 = {
  class: "pay-content",
  id: "pay-content"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "收银台", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请使用微信扫码支付", -1))
const _hoisted_45 = { class: "pay-code" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "logo-modal" }
const _hoisted_48 = { class: "logo-modal-line" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-modal-name" }, "图标", -1))
const _hoisted_50 = { class: "logo-modal-line" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-modal-name" }, "中文文案", -1))
const _hoisted_52 = { class: "logo-modal-line" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-modal-name" }, "英文文案", -1))

import { useRoute } from 'vue-router';
import Crumb from '@/components/Crumb.vue';
import CDelModal from '@/components/CDelModal.vue';
import { ref, unref, computed, reactive, onMounted, createVNode } from 'vue';
import http from '@/api/redpacket';
import router from '@/router';
import { documentPreview } from '@/assets';
import CreateRedEnvelopeRain from './components/createRedEnvelopeRain.vue';
import { ColumnProps } from 'ant-design-vue/es/table/interface';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import CUpload from '@/components/CUpload.vue';

// `qrcode` will be a ref of data URL
import { Pagination, Modal, Table, message, Popover, InputNumber, Input, Alert, Spin, Form, notification } from 'ant-design-vue';
import { getCurrentInstance } from 'vue';
import { getToken } from '@/plugins/cookie';
import { RollbackOutlined, QuestionCircleFilled, LoadingOutlined } from '@ant-design/icons-vue';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';
import { useDebounce } from '@/hooks/useDebounce'; //防抖

type Key = ColumnProps['key'];
interface DataItem {
  continued_at: string;
  created_at: string;
  direction: number;
  id: number;
  probability_winning: string;
  red_packed_amount: number;
  remaining_amount: any;
  start_at: number;
  status: number;
  studio_id: number;
  type: number;
  type_name: string;
}

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}

interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RedEnvelopeRain',
  setup(__props) {

const route = useRoute();
const aPagination = Pagination;
const aModal = Modal;
const aTable = Table;
const aPopover = Popover;
const aInputNumber = InputNumber;
const aInput = Input;
const aAlert = Alert;
const aSpin = Spin;
const aFormItem = Form.Item;

const indicator = createVNode(LoadingOutlined, {
  style: {
    fontSize: '24px',
  },
  spin: true,
});

const { proxy }: any = getCurrentInstance();
const token = getToken();
const studioId = router.currentRoute.value.params.studioId;
const tipsMsg = ref('功能需要配合打开微信登录，如果未开启微信登录功能，非微信用户将不能参与红包雨。');
const columns = ref([
  {
    title: '红包模式',
    dataIndex: 'type',
    align: 'center',
    slots: {
      customRender: 'type',
    },
  },
  {
    title: '持续时间',
    dataIndex: 'continued_at',
    align: 'center',
  },
  {
    title: '定时发送',
    align: 'center',
    dataIndex: 'start_at',
    width: '20%',
    slots: {
      customRender: 'start_at',
    },
  },
  {
    title: '状态',
    dataIndex: 'status',
    align: 'center',
    slots: {
      customRender: 'status',
    },
  },
  {
    title: '弹出',
    align: 'center',
    dataIndex: 'pop',
    slots: {
      customRender: 'pop',
    },
  },
  {
    title: '剩余金额',
    dataIndex: 'remaining_amount',
    align: 'center',
    slots: {
      customRender: 'remaining_amount',
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    align: 'center',
    slots: {
      customRender: 'operation',
    },
  },
]);

const columns2 = ref([
  {
    title: '用户名称',
    dataIndex: 'user_name',
    align: 'center',
    width: '12%',
  },
  {
    title: '姓名',
    dataIndex: 'name',
    align: 'center',
  },
  {
    title: '领取时间',
    align: 'center',
    dataIndex: 'created_at',
    width: '20%',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
    align: 'center',
  },
  {
    title: '地址',
    dataIndex: 'address',
    align: 'center',
    width: '18%',
  },
  {
    title: '领取奖品',
    align: 'center',
    dataIndex: 'goods_info',
    width: '18%',
    slots: {
      customRender: 'goods_info',
    },
  },
]);

const columns3 = ref([
  {
    title: '用户名称',
    dataIndex: 'user_name',
    align: 'center',
  },
  {
    title: '领取时间',
    align: 'center',
    dataIndex: 'created_at',
  },
  {
    title: '领取金额',
    align: 'center',
    dataIndex: 'amount',
  },
  {
    title: '国内外',
    dataIndex: 'country_type',
    align: 'center',
  },
  {
    title: '是否已提现（退回）',
    align: 'center',
    dataIndex: 'status',
    slots: {
      customRender: 'status',
    },
  },
  {
    title: '操作',
    align: 'center',
    dataIndex: 'country',
    slots: {
      customRender: 'country',
    },
  },
]);

const columns4 = ref([
  {
    title: '操作时间',
    dataIndex: 'created_at',
    align: 'center',
  },
  {
    title: '操作方式',
    align: 'center',
    dataIndex: 'type',
  },
  {
    title: '操作金额',
    align: 'center',
    dataIndex: 'single_amount',
    slots: {
      customRender: 'single_amount',
    },
  },
]);

const showLoading = ref<boolean>(false);
const tableList = ref<DataItem[]>([]);
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 1, // 总页数
  options: ['12', '24', '36', '48', '60'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});

const billPageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 1, // 总页数
});
const typeList = ref([
  {
    label: '全部',
    value: 0,
  },
  {
    label: '现金',
    value: 1,
  },
  {
    label: '礼包',
    value: 2,
  },
]);

const queryForm = reactive({
  type: 0, // 红包类型
  choice_all: ref(false), // 全选状态
  choice_arr: ref<Key[]>([]), // 勾选数组
  deletes: ref(false), // 删除弹窗
  winners: ref(false), // 中奖名单弹窗
  snatch_cash_ids: ref<Key[]>([]), // 现金中奖id
  isReturn: ref(false), // 是否显示一键退款
  billPop: ref(false), // 账单弹窗
  billList: ref<Key[]>([]), // 账单列表
  remaining_amount: ref<any>(''), // 余额
  amount: ref(100), // 充值金额
  pay_amount: ref(0), // 支付金额
  wx_code: ref(''), // 微信二维码
  recharge_order_no: ref(''), // 充值订单号
  recharge: ref(false), // 充值弹窗
  code_model: ref(false), // 二维码弹窗
  pay_status: ref(false), // 充值状态
  orderTimer: ref<any>(), // 轮询订单定时器
  create_red_packet: ref(false), // 创建页面显示
  red_packet_id: ref<any>(''), // 编辑红包id
  red_packet_type: ref(''), // 编辑红包type
  getWeCode: ref(0), //获取微信支付二维码  0旧接口  1新接口
});

const wechatPayMode = () => {
  http.wechat_pay_mode({ params: { studio_id: studioId } }).then((res) => {
    queryForm.getWeCode = res.data.data;
  });
};
wechatPayMode();

const openDelModal = () => {
  queryForm.deletes = false;
};

const routeJump = () => {
  router.push('/view_warrent/' + studioId + '/authorization?wx=' + 1);
};

// 全选
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});
const selectedRowKeys = ref<Key[]>([]);
const onSelectChange = (changableRowKeys: Key[]) => {
  queryForm.choice_arr = changableRowKeys;
  selectedRowKeys.value = changableRowKeys;
  queryForm.choice_all = changableRowKeys.length == tableList.value.length ? true : false;
};
const changeCheckAll = () => {
  let arr: any = [];
  queryForm.choice_all
    ? (tableList.value.forEach((i: any) => {
        arr.push(i.id);
      }),
      onSelectChange(arr))
    : onSelectChange([]);
};

// 删除红包雨
const delRedPackRain = () => {
  let params = {
    id: queryForm.choice_arr.join(','),
    studio_id: studioId,
  };
  http
    .delRedPackRain({ params })
    .then((res) => {
      if (res.data.code == 200) {
        message.success(res.data.message);
        getRedPackRainList(1);
        queryForm.deletes = false;
      }
    })
    .catch((res) => {
      queryForm.deletes = false;
      message.error(res.data.error);
    });
};

// 红包雨列表
const getRedPackRainList = (current: number) => {
  pageConfig.current = current;
  let params = {
    studio_id: studioId,
    type: queryForm.type,
    page: current,
    page_num: pageConfig.pageSize,
  };
  queryForm.choice_all = false;
  queryForm.choice_arr = [];
  showLoading.value = true;
  http
    .getRedPackRainList({ params: params })
    .then((res) => {
      showLoading.value = false;
      if (res.data.code == 200) {
        tableList.value = [...res.data.data.data];
        tableList.value.forEach((i) => (i['carry_out'] = false));
        pageConfig.totalSize = res.data.data.total;
      }
    })
    .catch((err) => {
      showLoading.value = false;
    });
};

// 获取余额
const getRemainingAmount = () => {
  let params = {
    studio_id: studioId,
  };
  http
    .getRemainingAmount({ params })
    .then((res) => {
      if (res.data.code == 200) {
        queryForm.remaining_amount = res.data.data;
      }
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
// 回退余额
const returnBalance = (item: any) => {
  let params = {
    studio_id: studioId,
    red_packed_id: item.id,
  };
  http
    .returnBalance(params)
    .then((res) => {
      if (res.data.code == 200) {
        message.success(res.data.message);
        getRemainingAmount();
        getRedPackRainList(1);
      }
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
// 充值
const cechargeMoney = () => {
  queryForm.recharge = true;
  queryForm.pay_amount = 0;
};
//金额格式转换
const parsePrice = (s: any) => {
  if (s) {
    var pay_money: any = s;
    pay_money >= 1 ? (pay_money = (Number(pay_money) + Number(pay_money * 0.03)).toFixed(2)) : pay_money;
    queryForm.pay_amount = pay_money;
  } else {
    queryForm.pay_amount = 0;
  }
};
const orderRecharge = () => {
  if (queryForm.pay_status) {
    queryForm.code_model = true;
    return;
  }
  if (queryForm.pay_amount < 0) message.error('请输入有效金额!');
  parsePrice(queryForm.amount);
  let params = {
    amount: queryForm.amount,
    payment_amount: queryForm.pay_amount,
    studio_id: studioId,
  };
  http
    .orderRecharge(params)
    .then((res) => {
      if (res.data.code == 200) {
        queryForm.recharge_order_no = res.data.data.order_no;
        queryForm.code_model = queryForm.pay_status = false;
        weChatScanPay();
      }
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};

// 微信支付二维码
const weChatScanPay = () => {
  let params = {
    order_no: queryForm.recharge_order_no,
    pay_type: 2,
    studio_id: studioId,
  };
  queryForm.code_model = queryForm.pay_status = true;
  if (queryForm.getWeCode) {
    http
      .newWeChatScanPay({ studio_id: studioId, order_no: queryForm.recharge_order_no })
      .then((res) => {
        queryForm.wx_code = res.data.data.code_url;
        queryForm.orderTimer = setInterval(() => {
          pollingOrder();
        }, 1000);
      })
      .catch((err) => message.error(err.data.error));
  } else {
    http
      .weChatScanPay({ params })
      .then((res) => {
        if (res.data.code == 200) {
          queryForm.wx_code = res.data.data;
          queryForm.orderTimer = setInterval(() => {
            pollingOrder();
          }, 1000);
        }
      })
      .catch((res) => message.error(res.data.error));
  }
};
// 支付状态
const pollingOrder = () => {
  http
    .pollingOrder({ order_no: queryForm.recharge_order_no })
    .then((res) => {
      if (res.data.data.code != 40003) {
        if (res.data.code == 200) {
          message.success(res.data.message);
          getRemainingAmount();
          clearInterval(queryForm.orderTimer);
          queryForm.code_model = queryForm.pay_status = false;
          queryForm.recharge = false;
          queryForm.wx_code = '';
        }
      }
    })
    .catch((res) => {
      queryForm.recharge = queryForm.code_model = queryForm.pay_status = false;
      message.error(res.data.error);
    });
};

const clearTimer = () => {
  queryForm.pay_status = false;
  clearInterval(queryForm.orderTimer);
};

// 弹出红包雨
const popUpImmediatelyRedPackedInfo = (item: any) => {
  let params = {
    studio_id: studioId,
    id: item.id,
  };
  item.carry_out = true;
  http
    .popUpImmediatelyRedPackedInfo(params)
    .then((res) => {
      if (res.data.code == 200) {
        message.success(res.data.message);
        getRedPackRainList(pageConfig.current);
      }
      item.carry_out = false;
    })
    .catch((res) => {
      item.carry_out = false;
      message.error(res.data.error);
    });
};

// 退款
const refundRainAmount = () => {
  http
    .refundRainAmount({ studio_id: studioId })
    .then((res) => {
      if (res.data.code == 200) {
        message.success(res.data.message);
        getRemainingAmount();
      }
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};

// 查看账单
const viewBillList = () => {
  queryForm.billPop = true;
  billPageConfig.current = 1;
  getAmountLog(1);
};
const getAmountLog = (current: number) => {
  let params = {
    studio_id: studioId,
    page: current,
    page_num: 10,
  };
  showLoading.value = true;
  http
    .getAmountLog({ params })
    .then((res) => {
      queryForm.billList = res.data.data.data;
      billPageConfig.totalSize = res.data.data.total;
      showLoading.value = false;
    })
    .catch((err) => {
      showLoading.value = false;
    });
};

const claimDetails = ref<any>({});
//查看领取详情
const viewDetails = (item: any) => {
  let params = {
    id: item.id,
    studio_id: studioId,
  };
  queryForm.winners = true;
  showLoading.value = true;
  if (item.type == 1) {
    // 现金
    http
      .cashClaimDetails({ params })
      .then((res) => {
        showLoading.value = false;
        if (res.data.code == 200) {
          claimDetails.value = res.data.data;
          claimDetails.value['type'] = item.type;
          res.data.data.snatch_cash_list.forEach((i: any) => {
            if (i.country == 2 && i.status == 0) {
              queryForm.snatch_cash_ids.push(i.id);
              queryForm.isReturn = true;
            } else {
              queryForm.isReturn = false;
            }
          });
        }
      })
      .catch((err) => {
        showLoading.value = false;
      });
  } else {
    // 礼包
    http
      .prizeClaimDetails({ params })
      .then((res) => {
        showLoading.value = false;
        if (res.data.code == 200) {
          claimDetails.value = res.data.data;
          claimDetails.value['type'] = item.type;
        }
      })
      .catch((err) => {
        showLoading.value = false;
      });
  }
};

// 一键退款 / 国外用户退款
const refundUerPackedAmount = (item: any) => {
  let params = {
    studio_id: studioId,
    red_packed_ids: item ? item.id : queryForm.snatch_cash_ids.join(','),
  };
  http.refundUerPackedAmount(params).then((res) => {
    if (res.data.code == 200) {
      message.success(res.data.message);
      getRemainingAmount();
    } else {
      message.error(res.data.error);
    }
  });
};

// 编辑红包雨
const editRedPacket = (item: any) => {
  queryForm.create_red_packet = true;
  queryForm.red_packet_id = item.id;
  queryForm.red_packet_type = item.type;
};

// 导出记录
const corn = ref(1);
const messageTip = ref();

const exportRecord = useDebounce((type: number, red_packed_id?: any) => {
  const data = {
    studio_id: studioId,
    type: type,
    is_cron_download: corn.value,
    red_packed_id: red_packed_id,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

// 新建or编辑 保存状态
function getCreateStatus(data: any) {
  queryForm.create_red_packet = data;
  getRedPackRainList(1);
  getRemainingAmount();
}

const init = () => {
  getRedPackRainList(1);
  getRemainingAmount();
};

onMounted(() => {
  clearInterval(queryForm.orderTimer);
});

init();
const url = computed(() => queryForm.wx_code);
const qrcode = useQRCode(url, { margin: 0 });

// 图标设置
const logoModal = ref(false);
const openLogoModal = () => {
  logoModal.value = !logoModal.value;
};

// S-上传照片
const fileList = ref([]);
const loading = ref<boolean>(false);
const imageUrl = ref<string>('');
const handleChange = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    imageUrl.value = info.file?.response?.data.url;
  }
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  } else loading.value = false;
  if (info.file.status === 'error') {
    loading.value = false;
    message.error('上传失败');
  }
};
const imageDel = () => {
  imageUrl.value = '';
};

const modelRef = ref({
  nameCN: '',
  nameEN: '',
});

const getLogoModalInfo = () => {
  http.get_red_packed_config_info({ params: { studio_id: studioId } }).then((res) => {
    imageUrl.value = res.data.data.red_packed_icon;
    modelRef.value.nameCN = res.data.data.ch_red_packed || '';
    modelRef.value.nameEN = res.data.data.en_red_packed || '';
  });
};
getLogoModalInfo();

const submit = () => {
  const data = {
    studio_id: studioId,
    red_packed_icon: imageUrl.value,
    ch_red_packed: modelRef.value.nameCN,
    en_red_packed: modelRef.value.nameEN,
  };
  http
    .set_red_packed_config(data)
    .then((res) => {
      message.success(res.data.message);
      openLogoModal();
    })
    .catch((err) => message.error(err.data.error));
};

// 新建红包雨
const createRedPacket = () => {
  queryForm.create_red_packet = true;
  queryForm.red_packet_id = '';
  queryForm.red_packet_type = '1';
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(route).meta?.title) + " ", 1),
        (queryForm.create_red_packet)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (queryForm.create_red_packet = false))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(RollbackOutlined))
              ]),
              default: _withCtx(() => [
                _createTextVNode("返回列表 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (!queryForm.create_red_packet)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(aAlert), {
                class: "red-packet-alert",
                message: tipsMsg.value,
                type: "warning",
                "close-text": "立即开启",
                "show-icon": "",
                onClose: routeJump
              }, null, 8, ["message"]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_button, {
                    class: "mod_btn order",
                    onClick: cechargeMoney
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("充值")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_7, "总金额：￥" + _toDisplayString(queryForm.remaining_amount), 1)
                ]),
                _createElementVNode("div", null, [
                  (queryForm.remaining_amount > 0)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        class: "mod_btn order",
                        onClick: refundRainAmount
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("退款")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_button, {
                    class: "mod_btn order",
                    onClick: openLogoModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("图标设置")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    class: "mod_btn order",
                    onClick: viewBillList
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("账单")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_a_button, {
                    class: "mod_search_form_func",
                    type: "primary",
                    onClick: createRedPacket
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新建红包雨")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_a_select, {
                      class: "mod_select",
                      value: queryForm.type,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.type) = $event)),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (getRedPackRainList(1))),
                      placeholder: "红包类型",
                      options: typeList.value
                    }, {
                      suffixIcon: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          class: "mod_select_icon",
                          "icon-class": "list_select"
                        })
                      ]),
                      _: 1
                    }, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_a_checkbox, {
                    class: "checkbox",
                    checked: queryForm.choice_all,
                    "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.choice_all) = $event)),
                    onChange: changeCheckAll
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("全选")
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _createVNode(_component_a_button, {
                    class: "mod_btn",
                    type: "link",
                    disabled: queryForm.choice_arr.length <= 0,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (queryForm.deletes = true)),
                    danger: ""
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        class: "mod_btn_icon",
                        "icon-class": "del"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 删除 ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createVNode(_unref(aTable), {
                loading: showLoading.value,
                "row-selection": _unref(rowSelection),
                columns: columns.value,
                "data-source": tableList.value,
                pagination: false,
                class: "table-list",
                rowKey: 
            (res,index) => {
              return res.id;
            }
          
              }, {
                type: _withCtx(({ record }) => [
                  (record.type == 1)
                    ? (_openBlock(), _createBlock(_component_svg_icon, {
                        key: 0,
                        style: {"width":"25px","height":"25px"},
                        "icon-class": "red_packet"
                      }))
                    : (_openBlock(), _createBlock(_component_svg_icon, {
                        key: 1,
                        style: {"width":"25px","height":"25px"},
                        "icon-class": "red_packet_prize"
                      }))
                ]),
                start_at: _withCtx(({ record }) => [
                  (record.start_at == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "未设置"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(record.start_at), 1))
                ]),
                status: _withCtx(({ record }) => [
                  (record.status == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        _hoisted_16,
                        _createTextVNode("未使用 ")
                      ]))
                    : _createCommentVNode("", true),
                  (record.status == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                        _hoisted_18,
                        _createTextVNode("已使用 ")
                      ]))
                    : _createCommentVNode("", true),
                  (record.status == 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                        _hoisted_20,
                        _createTextVNode("已退款 ")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                pop: _withCtx(({ record }) => [
                  (record.carry_out)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "执行中"))
                    : (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        class: "mod_btn",
                        type: "link",
                        disabled: record.status == 1 ? true : record.status == 2 ? true : false,
                        danger: "",
                        onClick: ($event: any) => (popUpImmediatelyRedPackedInfo(record))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass({ sendText: record.status == 0 })
                          }, "发送", 2)
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"]))
                ]),
                remaining_amount: _withCtx(({ record }) => [
                  _createElementVNode("span", null, _toDisplayString(record.remaining_amount) + "元", 1),
                  (record.type == 1 && record.remaining_amount > 0 && !record.carry_out)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "cursor",
                        style: {"color":"#0099ff","margin-left":"10px"},
                        onClick: ($event: any) => (returnBalance(record))
                      }, [
                        _createTextVNode(" 回退 "),
                        _createVNode(_unref(aPopover), { placement: "rightTop" }, {
                          content: _withCtx(() => [
                            _hoisted_23
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_22))
                    : _createCommentVNode("", true)
                ]),
                operation: _withCtx(({ record }) => [
                  _createVNode(_component_svg_icon, {
                    class: _normalizeClass(["mod_select_icon", record.status == 0 ? 'cursor' : 'discursor']),
                    "icon-class": "operation",
                    onClick: ($event: any) => (record.status == 0 && editRedPacket(record))
                  }, null, 8, ["class", "onClick"]),
                  _createElementVNode("img", {
                    src: _unref(documentPreview),
                    class: "img_ww cursor",
                    onClick: ($event: any) => (viewDetails(record))
                  }, null, 8, _hoisted_24)
                ]),
                _: 1
              }, 8, ["loading", "row-selection", "columns", "data-source", "rowKey"]),
              _createVNode(_unref(aPagination), {
                "show-quick-jumper": "",
                total: pageConfig.totalSize,
                current: pageConfig.current,
                "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((pageConfig.current) = $event)),
                "page-size": pageConfig.pageSize,
                "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((pageConfig.pageSize) = $event)),
                pageSizeOptions: pageConfig.options,
                "show-less-items": "",
                "show-size-changer": "",
                onChange: _cache[7] || (_cache[7] = ($event: any) => (getRedPackRainList(pageConfig.current))),
                onShowSizeChange: _cache[8] || (_cache[8] = ($event: any) => (getRedPackRainList(pageConfig.current)))
              }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(CreateRedEnvelopeRain, {
                "data-source": {
            studioId: _unref(studioId),
            redPacketId: queryForm.red_packet_id,
            redPacketType: queryForm.red_packet_type,
          },
                onCreateStatus: getCreateStatus
              }, null, 8, ["data-source"])
            ])),
        _createVNode(CDelModal, {
          visible: queryForm.deletes,
          centered: "",
          close: openDelModal,
          ok: delRedPackRain
        }, null, 8, ["visible"]),
        _createVNode(_unref(aModal), {
          visible: queryForm.winners,
          "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.winners) = $event)),
          title: "中奖名单",
          class: "winners-model",
          width: "900px",
          okText: "导出记录",
          onOk: _cache[10] || (_cache[10] = ($event: any) => (_unref(exportRecord)(claimDetails.value.type == 1 ? 21 : 24, claimDetails.value.id))),
          centered: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("p", _hoisted_28, [
                  _hoisted_29,
                  _createTextVNode(" " + _toDisplayString(claimDetails.value.type == 1 ? '现金红包' : '礼品红包'), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_30,
                  _createTextVNode(" " + _toDisplayString(claimDetails.value.start_at == 0 ? '未设置' : claimDetails.value.start_at), 1)
                ]),
                (claimDetails.value.type == 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                      _hoisted_32,
                      _createTextVNode(" " + _toDisplayString(claimDetails.value.red_packed_amount), 1)
                    ]))
                  : _createCommentVNode("", true),
                (claimDetails.value.type == 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                      _hoisted_34,
                      _createTextVNode(" " + _toDisplayString(claimDetails.value.snatch_amount), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", null, [
                _hoisted_35,
                _createTextVNode(" " + _toDisplayString(claimDetails.value.snatch_people_num) + " 人 ", 1)
              ]),
              (queryForm.isReturn)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "sendText cursor",
                    onClick: refundUerPackedAmount
                  }, "一键退款"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_unref(aTable), {
                loading: showLoading.value,
                columns: claimDetails.value.type == 1 ? columns3.value : columns2.value,
                "data-source": claimDetails.value.type == 1 ? claimDetails.value.snatch_cash_list : claimDetails.value.snatch_goods_list,
                pagination: false,
                bordered: ""
              }, _createSlots({ _: 2 }, [
                (claimDetails.value.type == 1)
                  ? {
                      name: "status",
                      fn: _withCtx(({ record }) => [
                        _createElementVNode("span", null, _toDisplayString(record.status == 1 ? '是' : record.status == 0 ? '否' : '已退回'), 1)
                      ]),
                      key: "0"
                    }
                  : undefined,
                (claimDetails.value.type == 1)
                  ? {
                      name: "country",
                      fn: _withCtx(({ record }) => [
                        (record.country == 2 && record.status == 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "sendText cursor",
                              onClick: ($event: any) => (refundUerPackedAmount(record))
                            }, "可退回", 8, _hoisted_37))
                          : _createCommentVNode("", true)
                      ]),
                      key: "1"
                    }
                  : undefined,
                (claimDetails.value.type == 2)
                  ? {
                      name: "goods_info",
                      fn: _withCtx(({ record }) => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.goods_info, (item, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: index + '-only'
                          }, _toDisplayString(item.title) + "x" + _toDisplayString(item.number) + "，", 1))
                        }), 128))
                      ]),
                      key: "2"
                    }
                  : undefined
              ]), 1032, ["loading", "columns", "data-source"])
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_unref(aModal), {
          visible: queryForm.billPop,
          "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((queryForm.billPop) = $event)),
          title: "账单",
          class: "bill-model",
          width: "900px",
          okText: "导出记录",
          onOk: _cache[15] || (_cache[15] = ($event: any) => (_unref(exportRecord)(22))),
          centered: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_unref(aTable), {
                loading: showLoading.value,
                columns: columns4.value,
                "data-source": queryForm.billList,
                pagination: false,
                bordered: "",
                rowKey: 
            (res) => {
              return res.id;
            }
          
              }, {
                single_amount: _withCtx(({ record }) => [
                  _createElementVNode("span", {
                    style: _normalizeStyle(record.fund_flow == '+' ? 'color:#FAAD14;' : 'color:#FA5555;')
                  }, _toDisplayString(record.fund_flow) + _toDisplayString(record.single_amount), 5)
                ]),
                _: 1
              }, 8, ["loading", "columns", "data-source", "rowKey"])
            ]),
            _createVNode(_unref(aPagination), {
              style: {"margin-top":"10px"},
              total: billPageConfig.totalSize,
              current: billPageConfig.current,
              "onUpdate:current": _cache[11] || (_cache[11] = ($event: any) => ((billPageConfig.current) = $event)),
              "page-size": billPageConfig.pageSize,
              "onUpdate:pageSize": _cache[12] || (_cache[12] = ($event: any) => ((billPageConfig.pageSize) = $event)),
              pagination: billPageConfig,
              onChange: _cache[13] || (_cache[13] = ($event: any) => (getAmountLog(billPageConfig.current))),
              "show-less-items": ""
            }, null, 8, ["total", "current", "page-size", "pagination"])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_unref(aModal), {
          visible: queryForm.recharge,
          "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((queryForm.recharge) = $event)),
          title: "充值",
          width: "300px",
          okText: !queryForm.pay_status ? '充值' : '充值中',
          onOk: orderRecharge,
          onCancel: _cache[18] || (_cache[18] = ($event: any) => ((queryForm.wx_code = ''), (queryForm.pay_status = false))),
          centered: ""
        }, {
          default: _withCtx(() => [
            _hoisted_39,
            _createVNode(_unref(aInputNumber), {
              value: queryForm.amount,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((queryForm.amount) = $event)),
              valueModifiers: { number: true },
              min: 100,
              max: 100000,
              precision: 2,
              step: "0.01",
              size: "small",
              style: {"width":"170px","height":"32px","margin-right":"10px"}
            }, null, 8, ["value"]),
            _createVNode(_unref(aPopover), { placement: "rightTop" }, {
              content: _withCtx(() => [
                _hoisted_40
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible", "okText"]),
        _createVNode(_unref(aModal), {
          visible: queryForm.code_model,
          "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((queryForm.code_model) = $event)),
          width: "300px",
          closable: false,
          footer: null,
          centered: "",
          onCancel: clearTimer
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("p", null, _toDisplayString(queryForm.pay_amount) + "元", 1),
                  (_unref(qrcode))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(qrcode),
                        alt: "QR Code"
                      }, null, 8, _hoisted_46))
                    : (_openBlock(), _createBlock(_unref(aSpin), {
                        key: 1,
                        style: {"width":"50px","margin":"50px auto"},
                        indicator: _unref(indicator)
                      }, null, 8, ["indicator"]))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_unref(aModal), {
          visible: logoModal.value,
          "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((logoModal).value = $event)),
          title: "图标设置",
          centered: "",
          onOk: submit
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createVNode(_unref(aFormItem), null, {
                  default: _withCtx(() => [
                    _createVNode(CUpload, {
                      "file-list": fileList.value,
                      "handle-change": handleChange,
                      loading: loading.value,
                      "image-name": imageUrl.value,
                      "click-stop": imageDel,
                      class: "ant_upload"
                    }, null, 8, ["file-list", "loading", "image-name"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode(_unref(aFormItem), { style: {"width":"100%"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aInput), {
                      value: modelRef.value.nameCN,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((modelRef.value.nameCN) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createVNode(_unref(aFormItem), { style: {"width":"100%"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aInput), {
                      value: modelRef.value.nameEN,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((modelRef.value.nameEN) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ])
  ], 64))
}
}

})